const textContents = {
    "startPage": {
      "Finland": {
        "fin": "suomeksi",
        "rus": "Финский"
      },
      "Russia": {
        "fin": "venäjäksi",
        "rus": "Русский"
      },
      "Start": {
        "fin": "Aloita peli",
        "rus": "Начать игру"
      },
      "GameName": {
        "fin": "Mitä Masha tekee kylässä?",
        "rus": "Что Маша делает в деревне?"
      },
      "Welcome": {
        "fin": "Valitse pelin kieli",
        "rus": "Выбери язык игры"
      }
    },
    "topMenu": {
      "NavbarFi": {
        "fin": "Su",
        "rus": "Фи"
      },
      "NavbarRu": {
        "fin": "Ve",
        "rus": "Ру"
      },
      "NavbarClose": {
        "fin": "X",
        "rus": "X"
      },
      "NavbarInfo": {
        "fin": "?",
        "rus": "?"
      },
      "GameTitle": {
        "fin": "Masha kylässä",
        "rus": "Маша в деревне"
      },
      "GameQuestion": {
        "fin": "Mitä Masha tekee kylässä?",
        "rus": "Что Маша делает в деревне?"
      }
    },
    "textGame": {
      "HowToPlay": {
        "fin": "Miten pelataan",
        "rus": "Как играть"
      },
      "HowToPlayText": {
          "fin": ["Pelistä saat selville, mitä Masha-tyttö teki, ", "kun hän asui venäläisessä kylässä.", "Jokaisessa ruudussa on oma tytön elämästä kertova kuva.", "Kuvan alapuolella on lause. Lue se ja muista.", "Tee lause itse seuraavan ruudun kuvassa hajallaan olevista sanoista.", " Kysymys–painike auttaa, ", "jos unohdat sanajärjestyksen lauseessa.", "Nuolilla «Takaisin» ja «Eteenpäin» ", "voit palata katsomaan suoritettuja tehtäviä.", "Pelin päätyttyä yritä kertoa omin sanoin, ", "mitä Masha teki kylässä.", "Peli sisältää 28 juonikuvaa.", "", "Onnea peliin!"],
          "rus": ["Из игры ты узнаешь, чем занималась ", "девочка Маша, живя в русской деревне.", "На каждом экране свой сюжет-картинка из жизни девочки.", "Под картинкой предложение.", "Прочитай его и запомни.", "Составь сам предложение из слов,", "  разбросанных на картинке, на следующем экране.", "  Кнопка «Вопрос» поможет,", "  если ты забыл порядок слов в предложении.", "  По стрелочкам «Назад» и «Вперёд» можно вернуться", "  и посмотреть выполненные задания.", "  Закончив игру, попробуй рассказать своими словами,", "  чем занималась Маша в деревне.", "  В Игре содержится 28 сюжетных картинок.", "  Удачи в игре!" ]
      },
      "Continue": {
        "fin": "Jatka",
        "rus": "Продолжить"
      },
      "GameOver": {
        "fin": "Hyvin tehty!",
        "rus": "Молодец!"
      },
      "FinishGame": {
        "fin": "Pelin loppu",
        "rus": "Конец игры"
      },
      "TasksDone": {
         "fin": "Kerro, mitä Masha teki koko päivän?",
        "rus": [ "Расскажи, чем была занята Маша весь день" ]
      },
      "SunText": {
          "fin": "Eräässä venäläisessä kylässä asui Masha-tyttö",
        "rus": [ "В одной русской деревне жила девочка Маша..." ]
      },
      "PlayAgain": {
        "fin": "Aloita alusta",
        "rus": "Начать сначала"
      }
    },
    "content": {
      "ProsipaetsjaUtrom": {
        "fin": "HERÄÄ AAMULLA",
        "rus": "ПРОСЫПАЕТСЯ УТРОМ"
      },
      "RaschecyvaetVolosy": {
        "fin": "KAMPAA HIUKSET",
        "rus": "РАСЧЁСЫВАЕТ ВОЛОСЫ"
      },
      "UmyvaetsjaVodoy": {
        "fin": "PESEYTYY KAIVOVEDELLÄ",
        "rus": "УМЫВАЕТСЯ ВОДОЙ ИЗ КОЛОДЦА"
      },
      "ZapletaetKosu": {
        "fin": "LETITTÄÄ HIUKSET",
        "rus": "ЗАПЛЕТАЕТ КОСУ"
      },
      "TopitPech": {
        "fin": "LÄMMITTÄÄ UUNIA",
        "rus": "ТОПИТ ПЕЧЬ"
      },
      "KormitKoshku": {
        "fin": "RUOKKII MURKA-KISSAA",
        "rus": "КОРМИТ КОШКУ МУРКУ"
      },
      "KormitKur": {
        "fin": "RUOKKII KANOJA JA HANHIA",
        "rus": "КОРМИТ КУРОЧЕК И ГУСОЧЕК"
      },
      "ZavtrakaetKashey": {
        "fin": "SYÖ AAMIAISPUUROA",
        "rus": "ЗАВТРАКАЕТ КАШЕЙ"
      },
      "PasetKorovu": {
        "fin": "PAIMENTAA LEHMÄÄ",
        "rus": "ПАСЁТ КОРОВУ"
      },
      "PasetOvec": {
        "fin": "PAIMENTAA LAMPAITA",
        "rus": "ПАСЁТ ОВЕЦ"
      },
      "PasetKozu": {
        "fin": "PAIMENTAA VUOHTA",
        "rus": "ПАСЁТ КОЗУ"
      },
      "KositSeno": {
          "fin": "KOKOAA HEINÄÄ HEINÄSEIPÄÄSEEN",
          "rus": "СОБИРАЕТ СЕНО В СТОГ"
      },
      "IdetZaVodoy": {
        "fin": "KANTAA VETTÄ",
        "rus": "НЕСЁТ ВОДУ"
      },
      "StiraetBelje": {
        "fin": "PESEE PYYKKIÄ",
        "rus": "СТИРАЕТ БЕЛЬЁ"
      },
      "Utjuzit": {
        "fin": "SILITTÄÄ",
        "rus": "УТЮЖИТ"
      },
      "StrjapaetPirozki": {
        "fin": "LEIPOO PIIRAKOITA",
        "rus": "СТРЯПАЕТ ПИРОЖКИ"
      },
      "Obedaet": {
        "fin": "SYÖ PÄIVÄLLISTÄ",
        "rus": "ОБЕДАЕТ"
      },
      "MoetPosudu": {
        "fin": "PESEE ASTIOITA",
        "rus": "МОЕТ ПОСУДУ"
      },
      "PodmetaetPol": {
        "fin": "LAKAISEE LATTIAA",
        "rus": "ПОДМЕТАЕТ ПОЛ"
      },
      "NarjazaetsjaSarafan": {
        "fin": "PUKEUTUU SARAFAANIIN",
        "rus": "НАРЯЖАЕТСЯ В САРАФАН"
      },
      "PoetTancuet": {
        "fin": "LAULAA JA TANSSII",
        "rus": "ПОЁТ ПЕСНИ И ТАНЦУЕТ"
      },
      "ChaySamovar": {
        "fin": "JUO TEETÄ SAMOVAARISTA",
        "rus": "ПЬЁТ ЧАЙ ИЗ САМОВАРА"
      },
      "VyshivaetSalfetku": {
        "fin": "KIRJOO PÖYTÄLIINAA",
        "rus": "ВЫШИВАЕТ САЛФЕТКУ"
      },
      "CshelkaetSemechki": {
          "fin": "ROUSKUTTAA AURINGONKUKAN SIEMENIÄ",
        "rus": "ЩЁЛКАЕТ СЕМЕЧКИ"
      },
      "DoitKorovu": {
        "fin": "LYPSÄÄ LEHMÄÄ",
        "rus": "ДОИТ КОРОВУ"
      },
      "PjotMoloko": {
        "fin": "JUO VASTALYPSETTYÄ MAITOA",
        "rus": "ПЬЁТ ПАРНОЕ МОЛОКО"
      },
      "PrjadetVeretenom": {
        "fin": "KEHRÄÄ VILLALANKAA VÄRTTINÄLLÄ",
        "rus": "ПРЯДЁТ ШЕРСТЬ ВЕРЕТЕНОМ"
      },
      "LozitsjaSpat": {
        "fin": "MENEE NUKKUMAAN",
        "rus": "ЛОЖИТСЯ СПАТЬ"
      }

    }
  }
export default textContents;